import {
  searchDictionary,
  seeLabel,
  dateFmt,
  toJSON,
  dateRange,
  currencyFmt,
  verify,
  getUINFO,
  dealNumber,
  setWXPayPath
} from './utils.js'

import CONSTANT from './constant.js'

var output = {};
output.install = function (Vue) {
  Vue.prototype.$getWord = searchDictionary;
  Vue.prototype.$dateFilter = dateFmt;
  Vue.prototype.$toJSON = toJSON;
  Vue.prototype.$dateRange = dateRange;
  Vue.prototype.$verify = verify;
  Vue.prototype.$getUINFO = getUINFO;
  Vue.prototype.$CONSTANT = CONSTANT;
  Vue.prototype.$currency = currencyFmt;
  Vue.prototype.$seeLabel = seeLabel;
  Vue.prototype.$dealNumber = dealNumber;
  Vue.prototype.$setWXPayPath = setWXPayPath;

  Vue.filter('getLabel', searchDictionary);
  Vue.filter('seeLabel', seeLabel);
  Vue.filter('currency', currencyFmt);
  Vue.filter('dateFilter', dateFmt);
}

export default output;



// WEBPACK FOOTER //
// ./src/common/index.js